import { type FC } from "react";

import { LegalAuthorityInfoStep } from "./LegalAuthorityInfoStep";

interface LegalAuthorityNotSureWillStepProps {
  onBack: () => void;
  onContinue: () => void;
}

export const LegalAuthorityNotSureWillStep: FC<LegalAuthorityNotSureWillStepProps> = ({
  onBack,
  onContinue,
}) => (
  <LegalAuthorityInfoStep onBack={onBack} onContinue={onContinue}>
    <p>Many families start here, and there's a path for this too.</p>
    <p>
      Wills often turn up in a desk drawer, a filing cabinet, a safe deposit box, or with an
      attorney who worked with the person who passed.
    </p>
    <p>Your path works either way. If a will turns up later, share it and your steps update.</p>
  </LegalAuthorityInfoStep>
);
